import { TreinamentoDropDown } from "../../models/treinamento_dropdown";
import { IGetTreinamentosDropDownUseCase } from "../../../presentation/useCases/read/get_treinamentos_dropdown_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * GetTreinamentosDropDownUseCase
 */

export class GetTreinamentosDropDownUseCase implements IGetTreinamentosDropDownUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) { }

  async getTreinamentosDropDown(): Promise<TreinamentoDropDown[]> {
    const response = this.repository.getTreinamentosDropDown();
    return response;
  }
}